import React from "react";
import "./Loader.css"; // Create a CSS file for styling the loader

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
